module.exports = __webpack_public_path__ + "static/media/youtube.a0d0f3dd.png";